import { TrackingDataProps } from '../../../../../../common/AnalyticsContext/LinkTracking';
import { applyTrackingId } from '../../../../../../common/AnalyticsContext/applyTrackingId';
import { Container, LogoContainer, Name, PromotionIcon } from './TopServicesBox.styles';

interface Props {
  className?: string;
  name: string;
  logoPath?: string;
  setValue: Setter<string>;

  topNavName?: string; //optional top-nav only name that 'replaces' the 'name' string for DISPLAY ONLY. not for search bar input.
}

export const TopServicesBox = ({
  className,
  name,
  logoPath,
  setValue,
  trackingId,
  topNavName,
}: Props & TrackingDataProps) => (
  <Container
    tabIndex={0}
    className={className}
    onClick={() => setValue(name)}
    onKeyDown={e => e.key === 'Enter' && setValue(name)}
    {...applyTrackingId(trackingId)}
  >
    <LogoContainer>{logoPath && <PromotionIcon path={logoPath} />}</LogoContainer>
    <Name>{topNavName ?? name}</Name>
  </Container>
);
